import { Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material';
import {
    getGetSupportTicket, getDeploymentTicket, getDomainRenewalData, getDomainStatusDetails, getAccountsHistory,
    getDomainOutstandingDetails, getDomainContactDetails
} from "../../http/CentralizedDataHttp";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import React, { useState, useEffect, useMemo } from "react";
import "../../assets/css/tab-view.css"; // Import CSS file for styles
import Div from '../Div';



const TabView = ({ domain_name }) => {

    const role = localStorage.getItem('role');

    const tabs = useMemo(() => {
        let allTabs = [
            "Active Plan Details",
            "Domain Invoice History",
            "Domain Account Outstanding",
            "Domain Contacts",
            "Domain Renewal Data",
            "Deployment Tickets",
            "Support Tickets",
        ];
        if (role !== 'ADMIN') {
            allTabs = allTabs.filter(tab => tab !== "Domain Invoice History");
        }
        return allTabs;
    }, [role]);

    const [activeTab, setActiveTab] = useState(tabs[0]);
    const [domain_details, setDomainDetails] = useState([])
    const [loading, setLoading] = useState(false);

    const tabConfigs = useMemo( () => ({
        "Deployment Tickets": {
            columns: ["Ticket Number","Subject", "Status",  "Closure Date",
                "Created At"],
            db_columns: ["ticket_number","subject", "status", "cf_ticket_closure_date", "created_at"],
            fetchData: async (domain_name) => {
                const response = await getDeploymentTicket(domain_name);
                return response?.domains || [];
            },
        },
        "Support Tickets": {
            columns: ["Ticket Number", "Subject", "Status", "Created At","Closed Time"],
            db_columns: ["ticket_number", "subject", "status", "create_time", "closedTime"],
            fetchData: async (domain_name) => {
                const response = await getGetSupportTicket(domain_name);
                return response?.tickets || [];
            },
        },

        "Domain Renewal Data": {
            columns: ['PLan', 'Product', 'Past Renewal Date'],
            db_columns: ["plan", "skuName", "shivaami_renewal_date"],
            fetchData: async (domain_name) => {
                const response = await getDomainRenewalData(domain_name);
                return response?.domains || [];
            }
        },
        "Active Plan Details": {
            columns: ['Product', 'Licensed Seat', 'Used Seats', 'plan', 'Source', 'Renewal Date'],
            db_columns: ['skuName', 'usedSeats', 'maxSeats', 'plan','source', 'shivaami_renewal_date'],
            fetchData: async (domain_name) => {
                const response = await getDomainStatusDetails(domain_name);
                return response?.domains || [];
            }
        },
        "Domain Invoice History": {
            columns: ['Plan Name', 'Invoice Number', 'Invoice Date', 'Invoice Status', 'Product Type'],
            db_columns: ['plan_name', 'invoice_no', 'invoice_date', 'invoice_status', 'product_type'],
            fetchData: async (domain_name) => {
                const response = await getAccountsHistory(domain_name);
                return response?.domains || [];
            }
        },
        "Domain Account Outstanding": {
            columns: ['Invoice Count', 'Balance'],
            db_columns: ['invoice_count', 'bcy_balance'],
            fetchData: async (domain_name) => {
                const response = await getDomainOutstandingDetails(domain_name);
                return response?.domains || [];
            }
        },
        "Domain Contacts": {
            columns: ['Contact Email', 'Contact Number', 'Company Name', 'Customer Phone', 'Source'],
            db_columns: ['contact_details_email', 'cont_number', 'company_name', 'cont_mobile', 'source'],
            fetchData: async (domain_name) => {
                const response = await getDomainContactDetails(domain_name);
                return response?.domains || [];
            }
        }

    }), [])


    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const data = {};

                for (const tab of tabs) {
                    const config = tabConfigs[tab];
                    if (config) {
                        data[tab] = await config.fetchData(domain_name);
                    } else {
                        data[tab] = [];
                    }
                    
                  
                }
                
                setDomainDetails(data);

            } catch (error) {
                console.error("Error fetching data:", error);
                setDomainDetails([]);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [activeTab, domain_name, tabConfigs, tabs]);


    const handleChange = (tab) => (event, isExpanded) => {
        setActiveTab(isExpanded ? tab : null); // Update expanded tab
    };

    return (
        <Div className="accordion-view-container">
            {loading ? (
                tabs.map(tab => (
                    <>
                    <Accordion key={tab} expanded={activeTab === tab} onChange={handleChange(tab)}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />} >
                             
                            <Typography> <strong>{tab}</strong></Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                        Loading...
                        </AccordionDetails>
                    </Accordion>

                    </>
                ))
               ) : (
                tabs.map(tab => (
                    <Accordion key={tab} expanded={activeTab === tab} onChange={handleChange(tab)}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />} >
                             
                            <Typography> <strong style={{fontSize:'larger'}}>{tab}</strong></Typography>
                        </AccordionSummary>
                        <AccordionDetails>

                            {domain_details[tab] && domain_details[tab].length > 0 ? (
                                <table className='table table-hover' >
                                    <thead>
                                        <tr>
                                      
                                            {tabConfigs[tab].columns.map((col, idx) => (
                                                <th key={idx} style={{ padding: '5px', fontSize: 'large' }}>{col}</th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {domain_details[tab].map((row, idx) => (
                                            <tr key={idx}>
                                                {tabConfigs[tab].columns.map((col, colIdx) => (
                                                    <td key={colIdx} style={{ padding: '5px',  }}>
                                                        {row[tabConfigs[tab].db_columns[colIdx]] || "N/A"}
                                                    </td>
                                                ))}
                                            </tr>
                                        ))}
                                    </tbody>
                                    {/* {domain_details[tab] === 'Domain Account History' ? 
                                    <>
                                        more...
                                    </> : null
                                    } */}
                                </table>
                            ) : (
                                <p>No data available for {activeTab}</p>
                            )}
                        </AccordionDetails>
                    </Accordion>
                ))
            )

            }
        </Div>
        
    );
};

export default TabView;
